import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["variant"];
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { set } from 'vue';
import { productGetters, priceTransform } from '@vsf-enterprise/commercetools';
import { debounce } from 'lodash-es';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import CartProduct from '@/components/Layout/Cart/CartProduct.vue';
import EmptyCart from '@/components/Layout/Cart/CartSidebar/EmptyCart.vue';
import UpSellProducts from '@/components/Layout/Cart/UpSellProductsCarousel.vue';
import RemovedGiftNotice from '~/components/Layout/Cart/RemovedGiftNotice.vue';
import CartSummary from '@/components/Layout/Cart/CartSidebar/CartSummary.vue';
import IconBadge from '@/components/ui/IconBadge.vue';
import InformationBox from '~/components/Molecules/InformationBox.vue';
import InformationItem from '~/components/Molecules/InformationItem.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzPaymentInfos from '~/components/_next/molecules/AzPaymentInfos.vue';
import { useProduct } from '~/composables/_next/useProduct';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useCart } from '~/composables/useCart';
import { useCoupon } from '~/composables/_next/cart/useCoupon';
import { useCartPreview } from '@/composables/useCheckout/modules/useCartPreview';
import { useFeatureFlagTalonOne } from '~/composables/_next/useFeatureFlagTalonOne';
import { useLocalization } from '~/composables/_next/useLocalization';
import { generateVariantString } from '@/utils';
import getImgByLabel from '@/utils/getImgByLabel';
import { gtmPushEvent, centimesToEuros, gtmPriceFormat, cartDiscountPrice } from '@/helpers/gtm';
import { checkIfProductIsGift } from '@/helpers/checkIfProductIsGift';
import { sortProducts } from '@/helpers/sortProductsWithDiscountProperty';
import { isProductExpressDeliveryCompatible } from '~/utils/ProductAvailability';
import { GiftingTypeFields } from '~/constants/productsConstants';
import { DOT_SYMBOL } from '~/constants';
import { useCartGetters } from '~/composables/_next/cart/useCartGetters';
export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarAddToCartOrganism',
  setup: function setup(__props) {
    var timeoutId;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUiState = useUiState(),
      isCartSidebarOpen = _useUiState.isCartSidebarOpen,
      openCartSidebar = _useUiState.openCartSidebar,
      closeCartSidebar = _useUiState.closeCartSidebar,
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $flag = _useNuxt2App.$flag,
      $ct = _useNuxt2App.$vsf.$ct,
      i18n = _useNuxt2App.i18n;
    var router = useRouter();
    var route = useRoute();
    var _useCart = useCart(),
      cart = _useCart.cart,
      removeItem = _useCart.removeItem,
      updateItemQty = _useCart.updateItemQty,
      clearCart = _useCart.clear,
      removeItemsIfNotAvailableInCountry = _useCart.removeItemsIfNotAvailableInCountry,
      setGiftRejection = _useCart.setGiftRejection,
      cartError = _useCart.error,
      countItemsWithoutGift = _useCart.countItemsWithoutGift;
    var _useCartGetters = useCartGetters(),
      getTotals = _useCartGetters.getTotals,
      getItemPrice = _useCartGetters.getItemPrice,
      getItemQty = _useCartGetters.getItemQty,
      getItemSku = _useCartGetters.getItemSku;
    var _useCoupon = useCoupon(),
      removeCartCoupon = _useCoupon.removeCartCoupon,
      legacyRemoveCartCoupon = _useCoupon.legacyRemoveCartCoupon;
    var _useFeatureFlagTalonO = useFeatureFlagTalonOne(),
      isTalonOneEnabled = _useFeatureFlagTalonO.isTalonOneEnabled;
    var _useCartPreview = useCartPreview(),
      discountedSubtotal = _useCartPreview.discountedSubtotal;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var hasRefusedGift = computed(function () {
      return rejectedGifts.value.length > 0;
    });
    var _useProduct = useProduct('CartSidebar'),
      search = _useProduct.search,
      fetchedProducts = _useProduct.products;
    var masterImages = ref({});
    var products = computed(function () {
      var _cart$value$lineItems, _cart$value;
      return (_cart$value$lineItems = (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.lineItems) !== null && _cart$value$lineItems !== void 0 ? _cart$value$lineItems : [];
    });
    var getPrice = function getPrice(value) {
      var _cart$value2, _cart$value2$totalPri;
      return priceTransform(value, ((_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : (_cart$value2$totalPri = _cart$value2.totalPrice) === null || _cart$value2$totalPri === void 0 ? void 0 : _cart$value2$totalPri.currencyCode) || null);
    };
    var productsWithMasterImage = computed(function () {
      if (!products.value.length) return [];
      return products.value.map(function (product) {
        var _product$price$discou, _checkIfProductIsGift, _checkIfProductIsGift2;
        var isGift = isTalonOneEnabled.value ? product.price.value.centAmount === 0 || product.lineItemMode === 'GiftLineItem' || ((_product$price$discou = product.price.discounted) === null || _product$price$discou === void 0 ? void 0 : _product$price$discou.value.centAmount) === 0 : !!(((_checkIfProductIsGift = checkIfProductIsGift(product)) === null || _checkIfProductIsGift === void 0 ? void 0 : (_checkIfProductIsGift2 = _checkIfProductIsGift.id) === null || _checkIfProductIsGift2 === void 0 ? void 0 : _checkIfProductIsGift2.indexOf('GIFT_')) > -1);
        return _objectSpread(_objectSpread({}, product), {}, {
          isGift: isGift
        });
      }).sort(function (productA, productB) {
        return sortProducts(productA, productB);
      }).map(function (_ref) {
        var productVariant = _ref.variant,
          product = _objectWithoutProperties(_ref, _excluded);
        var variant = _objectSpread(_objectSpread({}, productVariant), {}, {
          images: productVariant.images.concat(masterImages.value[product.productSlug] || [])
        });
        return _objectSpread(_objectSpread({}, product), {}, {
          variant: variant
        });
      });
    });
    var productsWithMasterImageFiltered = computed(function () {
      var filteredProducts = productsWithMasterImage.value.filter(function (product) {
        return !rejectedGifts.value.map(function (gift) {
          return gift.id;
        }).includes(product.id);
      });
      var mappedProducts = filteredProducts.map(function (product) {
        return _objectSpread(_objectSpread({}, product), {}, {
          isExpressDeliveryCompatible: isProductExpressDeliveryCompatible(product.variant, country)
        });
      });
      return mappedProducts;
    });
    var itemProduct = computed(function () {
      return productsWithMasterImage.value.map(function (object) {
        var _object$variant, _object$variant2;
        var _getItemPrice = getItemPrice(object),
          regular = _getItemPrice.regular,
          special = _getItemPrice.special;
        var discountPrice = cartDiscountPrice({
          regular: regular,
          quantity: object.quantity
        }, special);
        return {
          item_id: "SKU_".concat((_object$variant = object.variant) === null || _object$variant === void 0 ? void 0 : _object$variant.sku),
          item_sku: (_object$variant2 = object.variant) === null || _object$variant2 === void 0 ? void 0 : _object$variant2.sku,
          item_name: object.name,
          discount: discountPrice ? gtmPriceFormat(discountPrice) : '',
          discount_in_cents: discountPrice ? gtmPriceFormat(discountPrice, true) : '',
          quantity: object.quantity,
          price: centimesToEuros(object.price.value.centAmount),
          price_in_cents: object.price.value.centAmount,
          currency: object.price.value.currencyCode
        };
      });
    });
    var hasProductWithUnavailableExpresseDelivery = computed(function () {
      return productsWithMasterImageFiltered.value.findIndex(function (product) {
        return (product === null || product === void 0 ? void 0 : product.isExpressDeliveryCompatible) === false;
      }) !== -1;
    });
    var fetchMasterImages = function fetchMasterImages(slugs) {
      _toConsumableArray(new Set(slugs)).forEach(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(slug) {
          var images;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return search({
                  slug: slug
                });
              case 2:
                images = fetchedProducts.value.map(function (fp) {
                  return fp.images;
                }).flat();
                set(masterImages.value, slug, images);
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    };
    var isProductFreeByDiscountCode = function isProductFreeByDiscountCode(product) {
      var _cart$value3, _cart$value3$discount, _product$discountedPr, _product$discountedPr2;
      return ((_cart$value3 = cart.value) === null || _cart$value3 === void 0 ? void 0 : (_cart$value3$discount = _cart$value3.discountCodes) === null || _cart$value3$discount === void 0 ? void 0 : _cart$value3$discount.length) && product.discountedPricePerQuantity.length && ((_product$discountedPr = product.discountedPricePerQuantity[0].discountedPrice) === null || _product$discountedPr === void 0 ? void 0 : _product$discountedPr.includedDiscounts.length) && ((_product$discountedPr2 = product.discountedPricePerQuantity[0].discountedPrice) === null || _product$discountedPr2 === void 0 ? void 0 : _product$discountedPr2.value.centAmount) === 0;
    };
    var totals = computed(function () {
      return getTotals(cart.value);
    });
    var hasDiscount = computed(function () {
      var subtotal = parseFloat(totals.value.subtotal.toFixed(2));
      return subtotal > discountedSubtotal.value;
    });
    var updateQuantity = debounce(/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
        var product, quantity;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              product = _ref3.product, quantity = _ref3.quantity;
              _context2.next = 3;
              return updateItemQty({
                product: product,
                quantity: quantity
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }(), 250);
    var isInCheckout = function isInCheckout() {
      return ['information', 'shipping', 'payment', 'thank-you'].includes(router.currentRoute.name.split('_')[0]);
    };
    var rejectedGifts = computed(function () {
      var gifts = productsWithMasterImage.value.filter(function (product) {
        return product.isGift;
      });
      return gifts.filter(function (gift) {
        var _gift$custom, _gift$custom$customFi;
        var rejectionField = (_gift$custom = gift.custom) === null || _gift$custom === void 0 ? void 0 : (_gift$custom$customFi = _gift$custom.customFieldsRaw) === null || _gift$custom$customFi === void 0 ? void 0 : _gift$custom$customFi.find(function (fields) {
          return fields.name === GiftingTypeFields.Rejected;
        });
        if (rejectionField) {
          return rejectionField.value;
        } else {
          return false;
        }
      });
    });
    var removeCartItem = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(product) {
        var _giftItemDiscountAssi, giftItemDiscountAssigned;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!isProductFreeByDiscountCode(product)) {
                _context3.next = 11;
                break;
              }
              giftItemDiscountAssigned = cart.value.discountCodes.find(function (code) {
                if (code.discountCode.cartDiscounts.length) {
                  var _product$discountedPr3;
                  var discountCodesMap = (_product$discountedPr3 = product.discountedPricePerQuantity[0].discountedPrice) === null || _product$discountedPr3 === void 0 ? void 0 : _product$discountedPr3.includedDiscounts.map(function (item) {
                    var _item$discount;
                    return (_item$discount = item.discount) === null || _item$discount === void 0 ? void 0 : _item$discount.id;
                  });
                  return discountCodesMap.includes(code.discountCode.cartDiscounts[0].id);
                }
                return false;
              });
              if (!((_giftItemDiscountAssi = giftItemDiscountAssigned.discountCode) !== null && _giftItemDiscountAssi !== void 0 && _giftItemDiscountAssi.code)) {
                _context3.next = 10;
                break;
              }
              if (!isTalonOneEnabled.value) {
                _context3.next = 8;
                break;
              }
              _context3.next = 6;
              return removeCartCoupon(giftItemDiscountAssigned.discountCode.code);
            case 6:
              _context3.next = 10;
              break;
            case 8:
              _context3.next = 10;
              return legacyRemoveCartCoupon(giftItemDiscountAssigned.discountCode.code);
            case 10:
              return _context3.abrupt("return");
            case 11:
              if (!product.isGift) {
                _context3.next = 15;
                break;
              }
              _context3.next = 14;
              return setGiftRejection(product, true);
            case 14:
              return _context3.abrupt("return", _context3.sent);
            case 15:
              _context3.next = 17;
              return removeItem({
                product: product
              });
            case 17:
              if (products.value.length) {
                _context3.next = 21;
                break;
              }
              _context3.next = 20;
              return clearCart();
            case 20:
              if (isInCheckout()) {
                router.push(app.localePath({
                  name: 'index'
                }));
                toggleCartSidebar();
              }
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function removeCartItem(_x3) {
        return _ref5.apply(this, arguments);
      };
    }();
    var handleGoToCheckout = function handleGoToCheckout() {
      navigateToOrLogin({
        nextRoutePath: '/checkout',
        previousRoutePath: route.path
      });
      toggleCartSidebar();
    };
    onMounted(function () {
      if (route.hash === '#cart') openCartSidebar();
    });
    onUnmounted(function () {
      clearTimeout(timeoutId);
      closeCartSidebar();
    });
    watch(cartError, function () {
      console.error('failed while load Cart', cartError);
    });
    watch(route, function () {
      if ((route === null || route === void 0 ? void 0 : route.hash) === '#cart') openCartSidebar();
    });
    watch(isCartSidebarOpen, function () {
      timeoutId = setTimeout(function () {
        removeItemsIfNotAvailableInCountry(products.value, country);
      }, 500);
      if (isCartSidebarOpen.value && countItemsWithoutGift.value > 0) {
        gtmPushEvent('view_cart', {
          event_category: 'ecommerce',
          event_action: 'checkout',
          event_label: 'step1',
          event_name: 'view_cart',
          total_items: countItemsWithoutGift.value,
          ecommerce: {
            value: totals.value.total,
            value_in_cents: gtmPriceFormat(totals.value.total, true),
            currency: productsWithMasterImage.value[0].price.value.currencyCode,
            items: itemProduct.value
          }
        });
      }
    });
    watch(products, function () {
      if (!products.value.length) return;
      var slugs = products.value.filter(function (p) {
        var _p$variant, _p$variant$images;
        return !((_p$variant = p.variant) !== null && _p$variant !== void 0 && (_p$variant$images = _p$variant.images) !== null && _p$variant$images !== void 0 && _p$variant$images.length);
      }).map(function (p) {
        return p.productSlug;
      }).filter(function (slug) {
        return !masterImages.value[slug];
      });
      fetchMasterImages(slugs);
    }, {
      immediate: true,
      deep: true
    });
    return {
      __sfc: true,
      timeoutId: timeoutId,
      navigateToOrLogin: navigateToOrLogin,
      isCartSidebarOpen: isCartSidebarOpen,
      openCartSidebar: openCartSidebar,
      closeCartSidebar: closeCartSidebar,
      toggleCartSidebar: toggleCartSidebar,
      app: app,
      $flag: $flag,
      $ct: $ct,
      i18n: i18n,
      router: router,
      route: route,
      cart: cart,
      removeItem: removeItem,
      updateItemQty: updateItemQty,
      clearCart: clearCart,
      removeItemsIfNotAvailableInCountry: removeItemsIfNotAvailableInCountry,
      setGiftRejection: setGiftRejection,
      cartError: cartError,
      countItemsWithoutGift: countItemsWithoutGift,
      getTotals: getTotals,
      getItemPrice: getItemPrice,
      getItemQty: getItemQty,
      getItemSku: getItemSku,
      removeCartCoupon: removeCartCoupon,
      legacyRemoveCartCoupon: legacyRemoveCartCoupon,
      isTalonOneEnabled: isTalonOneEnabled,
      discountedSubtotal: discountedSubtotal,
      country: country,
      hasRefusedGift: hasRefusedGift,
      search: search,
      fetchedProducts: fetchedProducts,
      masterImages: masterImages,
      products: products,
      getPrice: getPrice,
      productsWithMasterImage: productsWithMasterImage,
      productsWithMasterImageFiltered: productsWithMasterImageFiltered,
      itemProduct: itemProduct,
      hasProductWithUnavailableExpresseDelivery: hasProductWithUnavailableExpresseDelivery,
      fetchMasterImages: fetchMasterImages,
      isProductFreeByDiscountCode: isProductFreeByDiscountCode,
      totals: totals,
      hasDiscount: hasDiscount,
      updateQuantity: updateQuantity,
      isInCheckout: isInCheckout,
      rejectedGifts: rejectedGifts,
      removeCartItem: removeCartItem,
      handleGoToCheckout: handleGoToCheckout,
      productGetters: productGetters,
      AzButton: AzButton,
      CartProduct: CartProduct,
      EmptyCart: EmptyCart,
      UpSellProducts: UpSellProducts,
      RemovedGiftNotice: RemovedGiftNotice,
      CartSummary: CartSummary,
      IconBadge: IconBadge,
      InformationBox: InformationBox,
      InformationItem: InformationItem,
      AzSidebar: AzSidebar,
      AzPaymentInfos: AzPaymentInfos,
      generateVariantString: generateVariantString,
      getImgByLabel: getImgByLabel,
      DOT_SYMBOL: DOT_SYMBOL
    };
  }
});